import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const Show = ({ open, onClose, itemData }) => {
  if (!itemData) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR');
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ 
        m: 0, 
        p: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Typography variant="h6">
          Détails de l'activité
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Nom
          </Typography>
          <Typography variant="body1" gutterBottom>
            {itemData.nom}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Description
          </Typography>
          <Typography variant="body1" gutterBottom>
            {itemData.description}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Période
          </Typography>
          <Typography variant="body1" gutterBottom>
            Du {formatDate(itemData.debut)} au {formatDate(itemData.fin)}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Ville
          </Typography>
          <Typography variant="body1" gutterBottom>
            {itemData.ville}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Type d'activité
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ textTransform: 'capitalize' }}>
            {itemData.type_activite}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Événement
          </Typography>
          <Typography variant="body1" gutterBottom>
            {itemData.evenement}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button 
          onClick={onClose}
          variant="contained"
          sx={{ 
            backgroundColor: 'primary.main',
            borderRadius: '8px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#333'
            }
          }}
        >
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

Show.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  itemData: PropTypes.shape({
    id: PropTypes.number,
    nom: PropTypes.string,
    description: PropTypes.string,
    debut: PropTypes.string,
    fin: PropTypes.string,
    ville: PropTypes.string,
    type_activite: PropTypes.string,
    evenement: PropTypes.string
  }),
};

export default Show;